import React                 from 'react';
import View                  from '@widesk-ui/components/View';
import Tooltip               from '@widesk-ui/components/Tooltip';
import { BgColorsOutlined }  from '@ant-design/icons';
import useDesignTokens       from '@/hooks/useDesignTokens';
import leftSidebarStore      from '@/TokamapEditor/stores/leftSidebarStore';
import type { ThemeLockRef } from '@/TokamapEditor/helpers/themeImposed';

export function ThemeLockTag({ lock }: { lock: ThemeLockRef; }) {
	const tokens = useDesignTokens();
	const linked = !!lock.target;

	return (
		<Tooltip title={linked ? `Imposé par le thème « ${lock.theme} » : cliquer pour le régler dans le thème.` : `Imposé par ${lock.theme} : se règle dans les thèmes, pas sur la forme.`}>
			<View
				row
				centerV
				gap={4}
				size={11.5}
				color={tokens.color.primary}
				onClick={linked ? () => leftSidebarStore.openThemeField(lock.target) : undefined}
				style={{
					fontWeight: 500,
					padding: '1px 8px',
					borderRadius: 999,
					maxWidth: 160,
					cursor: linked ? 'pointer' : undefined,
					background: `color-mix(in srgb, ${tokens.color.primary} 10%, transparent)`,
				}}
			>
				<BgColorsOutlined />
				<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lock.theme}</span>
			</View>
		</Tooltip>
	);
}

export function ThemeLockedControl({ lock, children }: { lock?: ThemeLockRef; children: React.ReactNode; }) {
	if (!lock) return <>{children}</>;

	const locked = (
		<div {...{ inert: '' }} aria-disabled style={{ opacity: 0.5, display: 'flex', flexDirection: 'column', gap: 'inherit' }}>
			{children}
		</div>
	);

	if (!lock.target) return locked;

	// `inert` soustrait le contrôle au pointeur : le clic tombe sur ce conteneur.
	return (
		<Tooltip title={`Régler dans le thème « ${lock.theme} »`}>
			<div onClick={() => leftSidebarStore.openThemeField(lock.target)} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 'inherit' }}>
				{locked}
			</div>
		</Tooltip>
	);
}
